'use client'

import dynamic from 'next/dynamic'
import { Hiro } from '@/ui/home/hiro'

// Lazy load Video on mobile for better performance
const Video = dynamic(
  () => import('@/ui/home/video').then((mod) => ({ default: mod.Video })),
  {
    loading: () => <div className="min-h-[400px]" />,
  },
)

// Lazy load below-the-fold components to reduce initial JS
const Tips = dynamic(() => import('@/ui/home/tips/Tips'), {
  loading: () => <div className="min-h-[400px]" />,
})
const Engage = dynamic(
  () => import('@/ui/home/engage').then((mod) => ({ default: mod.Engage })),
  {
    loading: () => <div className="min-h-[400px]" />,
  },
)
const Crm = dynamic(
  () => import('@/ui/home/crm').then((mod) => ({ default: mod.Crm })),
  {
    loading: () => <div className="min-h-[400px]" />,
  },
)
const Map = dynamic(
  () => import('@/ui/home/map').then((mod) => ({ default: mod.Map })),
  {
    loading: () => <div className="min-h-[400px]" />,
  },
)
const Why = dynamic(
  () => import('@/ui/home/why').then((mod) => ({ default: mod.Why })),
  {
    loading: () => <div className="min-h-[400px]" />,
  },
)
const Features = dynamic(
  () => import('@/ui/home/features').then((mod) => ({ default: mod.Features })),
  {
    loading: () => <div className="min-h-[400px]" />,
  },
)
const Community = dynamic(() => import('@/ui/home/community/Community'), {
  loading: () => <div className="min-h-[400px]" />,
})
const Cta = dynamic(
  () => import('@/ui/home/cta').then((mod) => ({ default: mod.Cta })),
  {
    loading: () => <div className="min-h-[400px]" />,
  },
)
const Blogs = dynamic(
  () => import('@/ui/home/blogs').then((mod) => ({ default: mod.Blogs })),
  {
    loading: () => <div className="min-h-[400px]" />,
  },
)

export default function Home() {
  return (
    <div className="flex flex-col md:gap-[190px] gap-[120px]">
      <div>
        <Video />
        <Hiro />
      </div>
      <Tips />
      <Engage />
      <Crm />
      <Map />
      <Why />
      <Features />
      <Community />
      <Cta />
      <Blogs />
    </div>
  )
}
